import { render, staticRenderFns } from "./questionnaire_bind.vue?vue&type=template&id=44a51972&scoped=true&"
import script from "./questionnaire_bind.vue?vue&type=script&lang=js&"
export * from "./questionnaire_bind.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire_bind.vue?vue&type=style&index=0&id=44a51972&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a51972",
  null
  
)

component.options.__file = "questionnaire_bind.vue"
export default component.exports